// removed by extract-text-webpack-plugin
module.exports = {"container":"_1jPNj7ZM4OB6zjYGeQannc"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Templates/Template/styles.css
// module id = 2973
// module chunks = 0